import React, { useState, useEffect } from "react";
import "../styles/mechventilatie.scss";
import MechventImage from "../assets/images/mechvent.png";


const MechVentilatie = () => {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  useEffect(() => {
    document.title = 'Mechanische Ventilatie - Fresh Air Care';
  }, []);

    return (
    <div className="mv-page">
      {/* ========== HERO ========== */}
      <section className="mv-hero">
        <div className="mv-container">
          <div className="mv-hero-content">
            <div className="mv-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              Mechanische Ventilatie
            </div>
            <h1 className="mv-hero-title">
              Frisse lucht, <span className="mv-accent">stille werking</span>
            </h1>
            <p className="mv-hero-description">
              Professioneel onderhoud en vervanging voor optimale luchtkwaliteit en energiebesparing.
            </p>
            <div className="mv-cta-row">
              <a href="#contact" className="cta-primary1" onClick={() => window.location.href = '#contact'}>
                Gratis Inspectie
              </a>
              <a href="/tarieven" className="cta-secondary1" onClick={() => window.location.href = '/tarieven'}>
                Bekijk Tarieven
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ========== INTRO TEXT SECTION ========== */}
      <section className="mv-section mv-section-light">
        <div className="mv-container">
          <div className="mv-split-header">
            <div className="mv-split-left">
              <h2 className="mv-split-title">Optimaal werkend ventilatiesysteem</h2>
            </div>
            <div className="mv-split-right">
              <p className="mv-split-description">
                Mechanische ventilatie zorgt voor een gezond binnenklimaat door vervuilde lucht af te voeren en frisse lucht binnen te laten. Voorkomt schimmel, vocht en muffe lucht.
              </p>
            </div>
          </div>

          <div className="mv-services-block">
            <h3 className="mv-services-subtitle">Wat wij bieden</h3>
            <p className="mv-services-intro">
              Van installatie tot onderhoud, wij zorgen voor een optimaal werkend ventilatiesysteem in uw woning.
            </p>
            
            <div className="mv-services-timeline">
              <div className="mv-timeline-item">
                <div className="mv-timeline-marker"></div>
                <div className="mv-timeline-content">
                  <h4>Professionele installatie</h4>
                  <p>Nieuwe systemen vakkundig geïnstalleerd voor optimale werking en langdurige prestaties</p>
                </div>
              </div>

              <div className="mv-timeline-item">
                <div className="mv-timeline-marker"></div>
                <div className="mv-timeline-content">
                  <h4>Vervanging ventilatieboxen</h4>
                  <p>Oude boxen vervangen door moderne, stille en energiezuinige modellen</p>
                </div>
              </div>

              <div className="mv-timeline-item">
                <div className="mv-timeline-marker"></div>
                <div className="mv-timeline-content">
                  <h4>Inspectie & afstelling</h4>
                  <p>Alle ventielen worden afgesteld op de juiste debieten voor optimale luchtstromen</p>
                </div>
              </div>

              <div className="mv-timeline-item">
                <div className="mv-timeline-marker"></div>
                <div className="mv-timeline-content">
                  <h4>Grondige reiniging</h4>
                  <p>Ventilatiekanalen en ventilatiebox professioneel gereinigd voor betere luchtkwaliteit</p>
                </div>
              </div>

              <div className="mv-timeline-item">
                <div className="mv-timeline-marker"></div>
                <div className="mv-timeline-content">
                  <h4>Regelmatig onderhoud</h4>
                  <p>Periodieke controle en onderhoud voor blijvende topkwaliteit en optimale werking</p>
                </div>
              </div>
            </div>

            <p className="mv-services-note">
              Bestaande woning of nieuwbouw, wij zorgen voor zorgeloos frisse lucht.
            </p>
          </div>
        </div>
      </section>

      {/* ========== ONDERHOUD ========== */}
      <section className="mv-section mv-section-dark" id="onderhoud">
        <div className="mv-container">
          <div className="mv-section-header">
            <h2 className="mv-section-title">Professioneel onderhoud</h2>
            <p className="mv-section-description">
              Houd je systeem stil, zuinig en hygiënisch met regelmatig onderhoud
            </p>
          </div>

          <div className="mv-maintenance-content">
            <div className="mv-maintenance-text">
              <div className="mv-maintenance-schedule">
                <h3>Onderhoudsschema</h3>
                <div className="mv-schedule-list">
                  <div className="mv-schedule-item">
                    <div className="mv-schedule-period">Klein onderhoud – Elke 2 jaar</div>
                    <div className="mv-schedule-task">
                      <strong>Wat wordt er gedaan:</strong>
                      <ul>
                        <li>Reinigen MV-box</li>
                        <li>Ventielen afstellen op juiste debieten</li>
                      </ul>
                    </div>
                  </div>
                  <div className="mv-schedule-item">
                    <div className="mv-schedule-period">Groot onderhoud – Elke 5 jaar</div>
                    <div className="mv-schedule-task">
                      <strong>Wat wordt er gedaan:</strong>
                      <ul>
                        <li>Reinigen MV-box</li>
                        <li>Kanalen professioneel reinigen</li>
                        <li>Ventielen afstellen op juiste debieten</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mv-maintenance-image">
              <img src={MechventImage} alt="Onderhoud mechanische ventilatie" />
            </div>
          </div>
        </div>
      </section>

      {/* ========== VERVANGEN ========== */}
      <section className="mv-section" id="vervangen">
        <div className="mv-container">
          <div className="mv-section-header">
            <h2 className="mv-section-title">Wanneer vervangen?</h2>
            <p className="mv-section-description">
              Moderne mechanische ventilatieboxen zijn stiller en veel zuiniger
            </p>
          </div>

          <div className="mv-replacement-grid">
            <div className="mv-replacement-card mv-replacement-card-warning">
              <div className="mv-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Oud systeem</h3>
              <p>Ouder dan 10-15 jaar</p>
            </div>
            <div className="mv-replacement-card mv-replacement-card-warning">
              <div className="mv-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Te veel geluid</h3>
              <p>Bromtoon of trillingen</p>
            </div>
            <div className="mv-replacement-card mv-replacement-card-warning">
              <div className="mv-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Werkt niet goed meer</h3>
              <p>Onvoldoende afzuiging of vochtproblemen</p>
            </div>
          </div>

          <div className="mv-cta-row mv-cta-center">
            <a href="#contact" className="cta-primary1" onClick={() => window.location.href = '#contact'}>
              Offerte Aanvragen
            </a>
            <a href="/tarieven" className="cta-secondary1 light" onClick={() => window.location.href = '/tarieven'}>
              Bekijk Tarieven
            </a>
          </div>
        </div>
      </section>

      {/* ========== FAQ ========== */}
      <section className="mv-section mv-section-light">
        <div className="mv-container">
          <div className="mv-section-header">
            <h2 className="mv-section-title">Veelgestelde vragen</h2>
            <p className="mv-section-description">
              Alles wat je moet weten over mechanische ventilatie onderhoud en vervanging
            </p>
          </div>

          <div className="mv-faq-grid">
            {[
              {
                q: "Wat is mechanische ventilatie?",
                a: "Mechanische ventilatie voert vervuilde en vochtige lucht actief af uit ruimtes zoals keuken, badkamer en toilet, terwijl frisse lucht via roosters binnenkomt. Dit zorgt voor een gezond binnenklimaat en voorkomt problemen zoals schimmel, vocht en muffe lucht.",
              },
              {
                q: "Hoe vaak is onderhoud nodig?",
                a: "Wij adviseren klein onderhoud elke 2 jaar (MV-box reinigen en ventielen afstellen) en groot onderhoud elke 5 jaar (inclusief kanalen reinigen). Regelmatig onderhoud voorkomt problemen en houdt je systeem optimaal werken.",
              },
              {
                q: "Hoe weet ik of mijn ventilatiesysteem toe is aan vervanging?",
                a: "Als het systeem oud is (meer dan 10-15 jaar), veel lawaai maakt, of niet goed meer werkt, is vervanging aan te raden. Moderne systemen zijn veel stiller, energiezuiniger en betrouwbaarder.",
              },
              {
                q: "Wat is de levensduur van een mechanisch ventilatiesysteem?",
                a: "Gemiddeld 10 tot 15 jaar, afhankelijk van gebruik en onderhoud. Met regelmatig professioneel onderhoud kun je de levensduur maximaliseren en de prestaties optimaal houden.",
              },
              {
                q: "Stellen jullie de ventielen af op de juiste debieten?",
                a: "Ja, wij stellen alle ventielen altijd af op de juiste debieten. We meten per ruimte en zorgen ervoor dat elke ruimte optimaal wordt geventileerd volgens de geldende normen en uw specifieke wensen.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`mv-faq-card ${open === i ? "open" : ""}`}
                onClick={() => toggle(i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" ? toggle(i) : null)}
              >
                <div className="mv-faq-question">
                  {item.q}
                  <span className="mv-faq-icon">{open === i ? "−" : "+"}</span>
                </div>
                {open === i && <div className="mv-faq-answer">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

        </div>
    );
};

export default MechVentilatie;

